import React from 'react'
import UserResults from '../component/users/UserResults'
import UserSearch from '../component/users/UserSearch'

const Home = () => {
  return (
    <>
    <UserSearch/>
    <UserResults/>      
    </>
  )
}

export default Home